export enum IncidentStatusType {
    Draft = 1,
    PendingReview = 2,
    ReviewedApproved = 3,
    ReviewedClosedRejected = 4,
    ReviewedCompleted = 5,
    ReviewNotRequired = 6
}

